import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "cw_cookie_consent_v1";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 1500);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };
  const dismiss = () => {
    localStorage.setItem(KEY, "dismissed");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-[#0a0a0a] text-white border border-white/10 shadow-2xl"
      data-testid="cookie-consent-banner"
    >
      <div className="p-5">
        <div className="flex items-start gap-3 mb-3">
          <Cookie className="h-4 w-4 text-red-400 mt-0.5 shrink-0" />
          <div className="flex-1">
            <div className="text-[10px] font-semibold tracking-[0.32em] uppercase text-red-400 mb-2">Cookies</div>
            <p className="text-[13px] text-gray-300 font-light leading-relaxed">
              We use a minimal set of cookies for cart persistence, login, age-verification, and basic analytics. See our{" "}
              <Link to="/privacy" className="underline hover:text-red-400">Privacy Policy</Link> for details.
            </p>
          </div>
          <button onClick={dismiss} aria-label="Dismiss" className="text-gray-400 hover:text-white">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex gap-2 mt-4">
          <button
            onClick={accept}
            className="flex-1 bg-red-400 hover:bg-red-500 text-[#0a0a0a] hover:text-white px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.18em] transition-colors"
            data-testid="cookie-consent-accept"
          >
            Accept
          </button>
          <button
            onClick={dismiss}
            className="px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-gray-300 border border-white/15 hover:bg-white/5"
            data-testid="cookie-consent-decline"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
